import React, { Component } from 'react';
import moment from 'moment-timezone';
import _ from 'underscore';
import EventEmitter from '../util/eventEmitter.js';
import * as uuid from 'uuid';
import styledComponents from 'styled-components';

const P = styledComponents.p`
  margin-bottom: 3px;
`;

/**
 * Converts the contents of the given element (date) to given timezones (one or more)
 */
class Timezone extends Component {
  constructor(props) {
    super(props);
    this.identifier = props.identifier || uuid.v4();
    this.state = { date: props.date };
    this.updateListener = (date) => this.setState({ date: date });
  }

  UNSAFE_componentWillMount() {
    EventEmitter.on(
      `/timezone_${this.identifier}_date_update`,
      this.updateListener,
    );
  }

  componentWillUnmount() {
    EventEmitter.removeListener(
      `/timezone_${this.identifier}_date_update`,
      this.updateListener,
    );
  }

  translate() {
    return _.uniq(
      this.props.zones.map((z) => (z === 'user' ? moment.tz.guess() : z)),
    );
  }

  format(zone) {
    let date = moment(this.state.date, moment.ISO_8601);

    return date.isValid() ? date.tz(zone).format(this.props.format) : '';
  }

  render() {
    return (
      <span>
        {this.translate().map((z, i) => {
          return (
            <P
              key={z}
              className='time-zone-item'
            >
              {this.format(z)}
              <If
                condition={
                  !_.isEmpty(this.props.labels) &&
                  !_.isEmpty(this.props.labels[i])
                }
              >
                <span className='timezoneLabel'>({this.props.labels[i]})</span>
              </If>
            </P>
          );
        })}
      </span>
    );
  }
}

module.exports = Timezone;
